import { FeatureAdoptionData } from 'shared/services/feature-adoption';

export const enum FeatureAdoptionTypes {
  orderReady = 1,
}

export type AdoptionData = FeatureAdoptionData<FeatureAdoptionTypes>;
